import { render, staticRenderFns } from "./ReservationsCashier.vue?vue&type=template&id=f58469a8&"
import script from "./ReservationsCashier.vue?vue&type=script&lang=js&"
export * from "./ReservationsCashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports